/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useContext, createContext } from 'react';
const FormControlContext = createContext({
    required: undefined,
    hasError: false,
    hasSuccess: false,
});
export const Provider = FormControlContext.Provider;
export const useFormControl = () => {
    const { required, hasError, hasSuccess, disabled } = useContext(FormControlContext);
    return { required, hasError, hasSuccess, disabled };
};
